export const faqs_en = [
    {
        question: "How can I become a BALGOD member?",
        answer:
        "To become a member, you must make an investment that contributes to increasing the extraction volume in BALGOD's projects.",
    },
    {
        question: "What is BALGOD MATCH?",
        answer:
        "It is a passive investment plan with a 2-year contract designed to maximize members' profitability.",
    },
    {
        question: "How does BALGOD MATCH work in the first year?",
        answer:
        "Each member must make a minimum investment of $38 per week through an automated payment.",
    },
    {
        question: "What is the maximum investment allowed in the first year?",
        answer:
        "No member can invest more than $100,000 in the first 52 weeks.",
    },
    {
        question: "What happens from week 53 in BALGOD MATCH?",
        answer:
        "No additional contributions are accepted, except for the $8 weekly membership fee.",
    },
    {
        question: "Why does each member have to pay $8 per week?",
        answer:
        "To cover administrative expenses and transaction costs that ensure the platform operates efficiently.",
    },
    {
        question: "What is the benefit of contributing and waiting 2 years?",
        answer:
        "The initial investment will be either 100% reimbursed or doubled at the end of the two-year contract.",
    },
    {
        question:
        "If a member invests $5,000 in the first year, how much will they have at the end of the contract?",
        answer: "They will have $10,000.",
    },
    {
        question: "What options does a member have at the end of the 2-year contract?",
        answer:
        "They can withdraw the funds, apply for a loan of 75% of their balance, or reinvest their capital.",
    },
    {
        question: "What is the estimated APR for BALGOD member loans?",
        answer: "Between 3% and 5%.",
    },
    {
        question: "What is the benefit of reinvesting after two years?",
        answer:
        "Members can earn an estimated annual return of 7% to 11%, depending on sales and quarterly reports.",
    },
    {
        question: "What is the minimum weekly investment in BALGOD MATCH?",
        answer: "$38 per week.",
    },
    {
        question: "What are the requirements to invest in BALGOD’s monetary fund?",
        answer:
        "An ITIN, EIN, or Social Security Number is required to comply with tax regulations.",
    },
    {
        question: "Does BALGOD accept members regardless of their immigration status?",
        answer: "Yes, as long as they meet the documentation requirements.",
    },
    {
        question: "How does BALGOD back its members' investments?",
        answer:
        "With precious materials, not cryptocurrencies or financial market assets.",
    },
    {
        question: "What documents are required to become a BALGOD member?",
        answer:
        "Passport, ID, or Driver’s License from the U.S.\nProof of address in the U.S.\nITIN, EIN, or Social Security Number.\nBank account or debit card.",
    },
    {
        question:
        "What happens if the client disagrees with the terms and conditions stated in the contract?",
        answer:
        "If the client disagrees, they must refrain from signing the contract, as no personalized modifications based on individual preferences are allowed.",
    },
    {
        question: "What must the client be capable of when signing this contract?",
        answer:
        "The client must be a natural person with the physical and mental capacity to commit to signing the contract.",
    },
    {
        question: "How should payments be made according to the contract?",
        answer:
        "Payments must be made according to the agreed payment schedule and number of installments, either through the accounts provided by BALGOD or via charges made to the client’s account as specified in the Application-Contract.",
    },
    {
        question: "How should the credit provided by the client to BALGOD be used?",
        answer:
        "The credit provided should be allocated to investments in mining businesses, real estate, hydrocarbons, and gas pipeline construction.",
    },
    {
        question: "What types of modifications are allowed in the contract?",
        answer:
        "Modifications are only allowed in the following cases: legal name change, address change, legal name change of the beneficiary, and extension of the membership fee payment deadlines.",
    },
    {
        question: "What is the minimum age for using BALGOD services?",
        answer:
        "The services are intended for users who are at least 21 years old. Individuals under 21 may not use or register for the services.",
    },
    {
        question: "What must the CLIENT do to execute this contract?",
        answer:
        "The CLIENT must sign the Application-Contract, understanding that signing it constitutes their express consent to the credit agreement.",
    },
    {
        question: "How can the CLIENT sign the Application-Contract?",
        answer:
        "The CLIENT can sign the Application-Contract using their fingerprint, handwritten signature, or electronic signature, as enabled by BALGOD.",
    },
    {
        question: "What value does the fingerprint have when signing the contract?",
        answer:
        "The fingerprint will be considered a substitute for the handwritten signature of the parties in this contract and will have the same binding effect and legal consequences, clearly demonstrating the parties' intent to execute the contract.",
    },
    {
        question: "What does the BALGOD MATCH contract cover regarding the credit?",
        answer:
        "This contract covers the granting of a liquidity credit that the CLIENT extends to BALGOD, the characteristics, terms, and conditions of which are described on the credit cover page and in the 'Credit Characteristics' section of the Application-Contract.",
    },
    {
        question: "How can the credit limit be reduced?",
        answer:
        "The credit limit may be reduced based on the CLIENT’s payment capacity and behavior. Such a reduction will be communicated to the CLIENT through the next account statement, email, letter, phone, or any other electronic means.",
    },
    {
        question: "Can BALGOD increase the credit limit?",
        answer:
        "Yes, BALGOD may increase the credit limit upon request and/or authorization from the CLIENT, based on the CLIENT’s payment capacity and behavior, although it is not obligated to do so.",
    },
    {
        question: "How can the credit amount be reduced?",
        answer:
        "The credit amount may be reduced by the amounts BALGOD incurs for the payment of insurance premiums as outlined in the Insurance Clause of BALGOD MATCH contract.",
    },
    {
        question: "How will the CLIENT be informed of a potential increase in their credit line?",
        answer:
        "BALGOD may increase the credit amount based on the CLIENT's behavior by sending an offer to the CLIENT through the established communication methods. The CLIENT will have 30 business days to accept or reject the increase.",
    },
    {
        question: "What part of the contract is provided to the CLIENT upon signing?",
        answer:
        "BALGOD will provide the CLIENT with the credit cover page, which is an integral part of this contract, along with the amortization table.",
    },
    {
        question: "How much can the CLIENT withdraw during the term of the contract?",
        answer:
        "The CLIENT may request a withdrawal of up to 75% of the outstanding balance at the time of the request, excluding the interest mentioned in the Application-Contract, once the 104-week/2-year contract has been completed.",
    },
    {
        question: "How can the CLIENT dispose of the credit?",
        answer:
        "The CLIENT can dispose of the credit through deposits made by BALGOD into the CLIENT’s account, either in full or in part, in one or more transactions.",
    },
    {
        question: "What must the CLIENT provide when executing the contract regarding the credit?",
        answer:
        "The CLIENT must provide the broadest and most effective receipt as legally required for the amount funded.",
    },
    {
        question: "What channels are available for requesting the disposal of the credit?",
        answer:
        "The available channels are:\n1. Through any BALGOD branch,\n2. Through electronic-banking withdrawals,\n3. Through automated means.",
    },
    {
        question:
        "What must the CLIENT comply with when making disposals through the mentioned channels?",
        answer:
        "The CLIENT must comply with the provisions of the clause titled 'OPERATIONS THAT MAY BE CONDUCTED USING AUTOMATED SYSTEMS, EQUIPMENT, ELECTRONIC MEANS, OR CARDS AND CONTRACTING THROUGH ELECTRONIC MEANS,' and, if applicable, the agreement the CLIENT has with BALGOD regarding the use of banking services through automated means.",
    },
    {
        question:
        "What happens if the CLIENT requests a disposal through automated means on non-business days or outside business hours?",
        answer:
        "Disposals requested through automated means on non-business days or outside business hours will be credited on the next business day.",
    },
    {
        question: "What information will BALGOD provide before each additional disposal of the credit?",
        answer:
        "BALGOD will display the annual fixed rate the CLIENT will receive for each disposal via the communication channels.",
    },
    {
        question: "How are the disposals made by the CLIENT verified?",
        answer:
        "The disposals made by the CLIENT will be verified with the corresponding accounting records of the deposits made, as specified in the 'credit characteristics' section of the Application-Contract.",
    },
    {
        question: "Under what conditions can disposals of the credit be made?",
        answer:
        "Disposals can be made only if there is no default by the CLIENT regarding any of the obligations set forth in this contract, if the automated systems through which disposals are requested are available, and if none of the causes for early maturity set forth in the contract occur.",
    },
    {
        question: "Can BALGOD limit the disposals of the credit?",
        answer:
        "Yes, BALGOD reserves the right to limit the number and amount to be disposed of, and such limitation will be notified in the subsequent account statement.",
    },
    {
        question: "What is the duration of the contract?",
        answer:
        "The duration of the contract is indefinite, and it will be specified at the time of signing the agreement.",
    },
    {
        question: "Who establishes the repayment term for the credit?",
        answer:
        "The CLIENT establishes the repayment term for the credit, which will be indicated in the credit statement and in the Application-Contract.",
    },
    {
        question: "Can the CLIENT cancel the credit?",
        answer:
        "Yes, the CLIENT can cancel the credit without liability within 6 (six) business days after signing the agreement, or one day before the automated payment for week 2 (two), as long as BALGOD has not used or activated the credit.",
    },
    {
        question: "How can the CLIENT request early termination of the contract?",
        answer:
        "The CLIENT can request early termination at any time by submitting a written request through the contact channels provided by BALGOD, or through electronic means if previously agreed upon.",
    },
    {
        question: "What happens once BALGOD receives the termination request?",
        answer:
        "Once BALGOD receives the request, it will block the corresponding credit line, meaning the CLIENT will not be able to make further deposits to the credit line.",
    },
    {
        question: "Are there any charges for early termination of the contract?",
        answer:
        "BALGOD will not charge any commission for early termination of the contract, and the CLIENT will not be responsible for any charges incurred after the termination of the contract, except for those already incurred but not reflected.",
    },
    {
        question: "What happens to additional products or services linked to the contract if the main contract is canceled?",
        answer:
        "If an additional product or service cannot exist without this contract, its termination will result in the simultaneous termination of those additional products or services. If those products can exist independently, the conditions of the remaining products may change.",
    },
    {
        question: "How will BALGOD proceed if there are outstanding debts at the time of termination request?",
        answer:
        "If there are outstanding debts, BALGOD will notify the CLIENT within one business day about the pending balance and, within 5 (five) business days of receiving the request, will provide the exact amount due to settle the contract.",
    },
    {
        question: "What happens if there is a balance in favor of the CLIENT upon termination of the contract?",
        answer:
        "If there is a balance in favor of the CLIENT, BALGOD will deliver it on the termination date. If the CLIENT does not need to visit the branch, the balance will be made available through the account provided by the CLIENT.",
    },
    {
        question: "What happens if the CLIENT wants to cancel the contract through another financial institution?",
        answer:
        "The CLIENT can agree in writing to terminate the contract through another financial institution, which will become the creditor and carry out the necessary procedures, charging a commission for such actions.",
    },
    {
        question: "How will BALGOD proceed if a receiving financial institution is used for the termination of the contract?",
        answer:
        "BALGOD will provide the receiving financial institution with necessary information regarding the balance and other details for the termination, and once the fund transfer is completed, all rights and obligations under the contract will be extinguished.",
    },
    {
        question: "What happens if BALGOD is the receiving financial institution?",
        answer:
        "If BALGOD is the receiving institution, it will receive termination requests from 'users' and retain the original documents that demonstrate the user's intention to terminate the contractual relationship with the transferring institution.",
    },
    {
        question: "How can the CLIENT dispose of the credit?",
        answer:
        "The CLIENT can dispose of the credit through deposits made by BALGOD into the CLIENT’s account, either in full or partially, in one or more transactions.",
    },
    {
        question: "What channels are available for the CLIENT to make dispositions of the credit?",
        answer:
        "The channels are:\n  a) Through any BALGOD branch.\n  b) Through electronic banking withdrawals.\n  c) Through automated means.",
    },
    {
        question: "What happens if the CLIENT requests dispositions outside business hours or on non-business days?",
        answer:
        "Dispositions requested outside business hours or on non-business days will be credited on the next business day.",
    },
    {
        question: "What conditions must be met for the CLIENT to make a disposition of the credit?",
        answer:
        "The conditions are:\n  (I) No default exists on the CLIENT’s part regarding any obligations.\n  (II) The automated systems must be available.\n  (III) No early termination conditions have occurred.",
    },
    {
        question: "What must the CLIENT do if they want to request early termination of the contract?",
        answer:
        "The CLIENT must submit a written request through the contact channels provided by BALGOD or, if previously agreed upon, through electronic means.",
    },
    {
        question: "When will the credit line be blocked after the termination request is made?",
        answer:
        "The credit line will be blocked on the same day BALGOD receives the termination request, and the CLIENT will not be able to make further dispositions.",
    },
    {
        question: "What happens to additional products or services linked to this contract if it is terminated?",
        answer:
        "If the additional products or services cannot exist without this contract, their termination will coincide with the termination of this contract. If they can exist independently, their conditions may be modified.",
    },
    {
        question: "What happens if the CLIENT has a balance in their favor after the contract is terminated?",
        answer: "The balance in favor of the CLIENT will be delivered on the date the contract is terminated. If the CLIENT does not need to visit the branch, the balance will be made available through the account specified by the CLIENT."
    },
    {
        question: "What happens if the CLIENT decides to terminate the contract through another financial institution?",
        answer: "The CLIENT can request termination through another financial institution, which will settle the contract and carry out the necessary procedures. BALGOD will provide the required information about the balance and other details."
    },
    {
        question: "How will the funds made by the CLIENT be applied?",
        answer: "The funds will be applied in the following order: (I) Taxes, (II) Commissions, (III) Monetary interest, (IV) Premium(s), (V) Past-due ordinary interest, (VI) Outstanding principal balance, (VII) Current ordinary interest, (VIII) Principal amortization due."
    },
    {
        question: "What happens if the CLIENT wants to restructure their credit before the maturity date?",
        answer: "The CLIENT can restructure their credit, but the maturity date must not exceed the expiration date of the contract."
    },
    {
        question: "How will the CLIENT make the payment for the credit?",
        answer: "The payment of the credit will be made by the CLIENT at the BALGOD office, according to the payments and dates set forth in the signed document, to cover the total or partial withdrawal of the credit."
    },
    {
        question: "How will the amount owed by the CLIENT be determined in each disbursement?",
        answer: "Each disbursement will consist of the sum of the principal, the corresponding amount of interest, commissions, applicable insurance premiums, and any other accessories generated, along with the value-added tax (VAT) on interest, commissions, and/or insurance premiums."
    },
    {
        question: "What should the CLIENT do if the frequency of payroll or payments changes?",
        answer: "The CLIENT must notify BALGOD in advance about the change in frequency of their payments to adjust the credit disbursement dates."
    },
    {
        question: "How will the payment of the owed funds by the CLIENT be made?",
        answer: "The payment of the owed funds will be made through a charge to the deposit account identified in the 'Credit Features' section or any other account designated by the CLIENT."
    },
    {
        question: "What is considered a payroll loan?",
        answer: "A payroll loan is a loan in which BALGOD and the CLIENT agree that the funding for the corresponding debts will be made through charges to the respective amounts in the ordering account (the account into which the CLIENT receives deposits or transfers for benefits payments)."
    },
    {
        question: "How can the CLIENT designate a loan as a payroll loan?",
        answer: "The CLIENT can designate the loan as a payroll loan either at the time it is granted or at a later date, by using the direct debit form and signing the mandate in favor of BALGOD, allowing it to manage the loan’s direct debit with any other financial institution holding the ordering account."
    },
    {
        question: "What is the maximum amount a CLIENT can associate with a payroll loan?",
        answer: "The CLIENT can associate loans, provided they do not exceed $100,000 USD (one hundred thousand U.S. dollars)."
    },
    {
        question: "What happens if the CLIENT revokes the mandate or cancels the direct debit?",
        answer: "If the CLIENT revokes the mandate and/or requests the cancellation of the direct debit, BALGOD will be authorized to reduce the applicable ordinary interest rate by 20 percentage points from the rate originally agreed upon in the contract. The CLIENT will be notified via the account statement and may also be notified through the agreed-upon electronic channels with 30 days' notice before the ordinary interest rate is modified."
    },
    {
        question: "Who will address objections regarding charges to the loan?",
        answer: "Objections regarding charges will be addressed by the financial institution, referred to as the 'BANK OF THE BORROWER,' with which the CLIENT holds the ordering account as of the date of the objection request."
    },
    {
        question: "Can the CLIENT cancel the direct debit at any time?",
        answer: "Yes, the CLIENT may cancel the direct debit at any time and can make direct payments to the accounts provided to BALGOD."
    },
    {
        question: "What is the late payment interest rate for the CLIENT?",
        answer: "The CLIENT agrees to pay late payment interest starting the day after the third consecutive unpaid funding's due date. The rate will be calculated by multiplying the ordinary interest rate by 2 (two)."
    },
    {
        question: "When does the late payment interest start accruing?",
        answer: "The late payment interest starts accruing after the third consecutive unpaid funding, and it continues until the funding is made."
    },
    {
        question: "How is the interest calculated?",
        answer: "The interest is calculated based on a 360-day year, and it will accrue for the actual number of days the balance remains overdue."
    },
    {
        question: "What happens if the CLIENT fails to make payments after bringing the account up to date?",
        answer: "If the CLIENT fails to make payments after bringing the account up to date, late payment interest will be generated again under the same terms."
    },
    {
        question: "Can the CLIENT make early fundings of their loan?",
        answer: "Yes, the CLIENT may make early or advanced fundings at any time, as specified in the application-contract."
    },
    {
        question: "What conditions must be met for BALGOD to accept early payments?",
        answer: "The CLIENT must request the early payment and be current on all payable amounts. The early payment must also be equal to or greater than the amount due for the corresponding period."
    },
    {
        question: "How will the early payment be applied?",
        answer: "The early payment will be applied exclusively to the outstanding balance."
    },
    {
        question: "What happens if the early funding amount is not sufficient to fully amortize the balance?",
        answer: "The CLIENT must inform BALGOD if the early funding should reduce the amount of pending periodic payments or decrease the number of pending payments."
    },
    {
        question: "Can the CLIENT make advanced fundings for upcoming payments?",
        answer: "Yes, the CLIENT can make advanced fundings for periods not yet due, which will be applied to cover the following immediate periodic payments."
    },
    {
        question: "What happens if a payment exceeds the amount due?",
        answer: "The CLIENT must provide a signed written statement authorizing the excess funds to cover upcoming payments instead of early repayment of the principal. Or through the member account at www.balgod.com"
    },
    {
        question: "What does BALGOD provide after receiving early or advanced payments?",
        answer: "BALGOD will provide the CLIENT with an updated amortization schedule and a receipt for each early or advanced funding received."
    },
    {
        question: "What commissions is the CLIENT required to pay BALGOD?",
        answer: "The CLIENT must pay a commission for the administration of the loan, which will be paid weekly from the outstanding balance, as well as a commission for each loan disbursement and for collection in case of overdue and unfunded balances."
    },
    {
        question: "When is the commission for loan administration due?",
        answer: "The commission for administration is paid weekly from the outstanding balance to the account specified in the application-contract."
    },
    {
        question: "What is the commission for additional disbursement?",
        answer: "For each disbursement of the loan, the CLIENT will pay a commission, the amount of which is specified in the application-contract. This is due when the disbursement is made."
    },
    {
        question: "When is the collection commission generated?",
        answer: "The collection commission is generated starting on the sixth calendar day after the due date of the respective funding and can be applied for up to three consecutive unpaid payments."
    },
    {
        question: "Is the CLIENT obligated to pay the collection commission?",
        answer: "Yes, the CLIENT must pay the collection commission when it is generated, and it applies to the overdue and unfunded balance until the CLIENT fully funds the overdue amounts."
    },
    {
        question: "When does the CLIENT incur in late payment interest?",
        answer: "The CLIENT incurs in late payment interest if they fail to pay the required amount after the third consecutive unpaid funding. The interest rate will be double the ordinary interest rate."
    },
    {
        question: "How is the late payment interest calculated?",
        answer: "Late payment interest is calculated based on a 360-day year, accruing on the overdue balance for the actual number of days elapsed."
    },
    {
        question: "Can the CLIENT make early or advanced fundings?",
        answer: "Yes, the CLIENT can make early or advanced fundings at any time, provided they are current on their loan payments and the amount is equal to or greater than the payment due for the corresponding period."
    },
    {
        question: "What commissions does the CLIENT have to pay?",
        answer: "The CLIENT must pay a commission for loan administration, additional disbursements, and a collection commission for overdue amounts. These commissions are specified in the credit statement and the application-contract."
    },
    {
        question: "When is the collection commission applied?",
        answer: "The collection commission is applied starting on the sixth calendar day following the due date of the respective funding and may be applied for up to three consecutive unpaid payments."
    },
    {
        question: "What happens if the CLIENT has overdue funding?",
        answer: "If the CLIENT has overdue funding, BALGOD is authorized to charge the overdue amount against any liquid and payable debt the CLIENT has in their deposit accounts at BALGOD."
    },
    {
        question: "When will the CLIENT be notified about the overdue charge?",
        answer: "BALGOD will notify the CLIENT through the account statement after making the overdue charge."
    },
    {
        question: "What happens if the CLIENT dies?",
        answer: "The CLIENT's beneficiary must notify BALGOD within 7 business days of the death. The outstanding balance will be frozen until the beneficiary formally claims the balance with the required documentation."
    },
    {
        question: "Can the CLIENT appoint multiple beneficiaries?",
        answer: "No, the CLIENT can only appoint one irrevocable beneficiary, and this must be stated in the cover page of the contract."
    },
    {
        question: "When can BALGOD declare the loan amount due before the agreed term?",
        answer: "BALGOD can declare the loan due before the agreed term if the CLIENT fails to comply with the contract or in specific cases like bankruptcy or insufficient funds in the deposit account."
    },
    {
        question: "Can the CLIENT be relieved from compliance?",
        answer: "Yes, but only with prior written consent from BALGOD's legal representatives."
    },
    {
        question: "Is the CLIENT required to fulfill their obligations in the event of a fortuitous event or force majeure?",
        answer: "Yes, the CLIENT is obligated to fulfill their obligations even in cases of fortuitous events or force majeure."
    },
    {
        question: "Does BALGOD have the right to modify the credit terms?",
        answer: "Yes, BALGOD reserves the right to restrict the amount or period of the credit, or even terminate the contract by giving prior written notice to the CLIENT."
    },
    {
        question: "Is the CLIENT still obligated to pay if the contract is terminated?",
        answer: "Yes, the CLIENT is still obligated to fully fund the amounts offered and their accessories as per the contract until all contributions are made."
    },
    {
        question: "Does the omission of rights by BALGOD imply a waiver of those rights?",
        answer: "No, the omission of rights does not imply a waiver. The partial or singular exercise of rights will be governed by the content of the contract, not by the titles of the clauses."
    },
    {
        question: "When does the BALGOD Match start?",
        answer: "The BALGOD Match starts after the monetary contributions made during the first year (52 weeks or 26 biweekly periods)."
    },
    {
        question: "What percentage of reimbursement does the BALGOD Match offer?",
        answer: "It offers a 100% APR reimbursement based on the total contributions made during the first year."
    },
    {
        question: "What is the maximum contribution limit during the first year?",
        answer: "The maximum limit is $100,000 USD per member during the first year."
    },
    {
        question: "Is the membership fee refundable?",
        answer: "No, the membership fee is non-refundable and does not form part of the BALGOD Match."
    },
    {
        question: "What is the total cost of the membership?",
        answer: "The total cost of the membership is $832 USD."
    },
    {
        question: "What is the minimum weekly payment?",
        answer: "The minimum weekly payment is $30 USD or $60 USD biweekly."
    },
    {
        question: "Will monetary contributions be accepted after the first year?",
        answer: "No, monetary contributions will not be accepted after the first year, except for the membership fee payment as stated in the clause."
    },
    {
        question: "Can I withdraw my contributions and assets before the contract ends?",
        answer: "No, contributions and assets cannot be withdrawn until the contract is completed."
    },
    {
        question: "How is the BALGOD MATCH shown in the user’s account?",
        answer: "The BALGOD MATCH will be displayed in the user’s account from the outset, but its effect will start in the second year, as per the clause."
    },
    {
        question: "What is the total minimum contribution for the first year?",
        answer: "The total minimum contribution for the first year is $1,560 USD, with a maximum limit of $100,000 USD."
    },
    {
        question: "What is the total membership cost for two years?",
        answer: "The total membership cost for two years is $832 USD."
    },
    {
        question: "Will monetary contributions be accepted after week 53?",
        answer: "No, no monetary contributions will be accepted after week 53, except for the membership fee payment."
    },
    {
        question: "What happens with the monetary contribution in the second year?",
        answer: "No additional monetary contributions will be accepted in the second year, starting from week 53, except for the membership fee payment."
    },
    {
        question: "How many calendar days does a CLIENT have to request a clarification for a disputed transaction under $500 USD?",
        answer: "90 days"
    },
    {
        question: "For transactions exceeding $10,000 USD, within how many calendar days must a CLIENT submit their written objection to BALGOD?",
        answer: "45 days"
    },
    {
        question: "What is the maximum period within which BALGOD must provide a written response after receiving the required documentation from the CLIENT?",
        answer: "45 days (or 180 days for international transactions)"
    },
    {
        question: "What must a CLIENT do if they wish to dispute a transaction exceeding $10,000 USD?",
        answer: "Visit a BALGOD branch to submit the dispute, or through member account at www.balgod.com"
    }
];

export const faqs_es = [
  {
    "question": "¿Cómo puedo convertirme en miembro de BALGOD?",
    "answer": "Para convertirte en miembro, debes hacer una inversión que contribuya a aumentar el volumen de extracción en los proyectos de BALGOD."
  },
  {
    "question": "¿Qué es BALGOD MATCH?",
    "answer": "Es un plan de inversión pasiva con un contrato de 2 años diseñado para maximizar la rentabilidad de los miembros."
  },
  {
    "question": "¿Cómo funciona BALGOD MATCH en el primer año?",
    "answer": "Cada miembro debe hacer una inversión mínima de $38 por semana a través de un pago automatizado."
  },
  {
    "question": "¿Cuál es la inversión máxima permitida en el primer año?",
    "answer": "Ningún miembro puede invertir más de $100,000 en las primeras 52 semanas."
  },
  {
    "question": "¿Qué sucede a partir de la semana 53 en BALGOD MATCH?",
    "answer": "No se aceptan contribuciones adicionales, excepto la cuota semanal de membresía de $8."
  },
  {
    "question": "¿Por qué cada miembro debe pagar $8 por semana?",
    "answer": "Para cubrir los gastos administrativos y los costos de transacción que aseguran el funcionamiento eficiente de la plataforma."
  },
  {
    "question": "¿Cuál es el beneficio de contribuir y esperar 2 años?",
    "answer": "La inversión inicial será reembolsada al 100% o duplicada al final del contrato de dos años."
  },
  {
    "question": "Si un miembro invierte $5,000 en el primer año, ¿cuánto tendrá al final del contrato?",
    "answer": "Tendrá $10,000."
  },
  {
    "question": "¿Qué opciones tiene un miembro al final del contrato de 2 años?",
    "answer": "Puede retirar los fondos, solicitar un préstamo del 75% de su saldo o reinvertir su capital."
  },
  {
    "question": "¿Cuál es la tasa de APR estimada para los préstamos de miembros de BALGOD?",
    "answer": "Entre el 3% y el 5%."
  },
  {
    "question": "¿Cuál es el beneficio de reinvertir después de dos años?",
    "answer": "Los miembros pueden obtener un rendimiento anual estimado del 7% al 11%, dependiendo de las ventas e informes trimestrales."
  },
  {
    "question": "¿Cuál es la inversión mínima semanal en BALGOD MATCH?",
    "answer": "$38 por semana."
  },
  {
    "question": "¿Cuáles son los requisitos para invertir en el fondo monetario de BALGOD?",
    "answer": "Se requiere un ITIN, EIN o número de Seguro Social para cumplir con las regulaciones fiscales."
  },
  {
    "question": "¿BALGOD acepta miembros independientemente de su estatus migratorio?",
    "answer": "Sí, siempre que cumplan con los requisitos de documentación."
  },
  {
    "question": "¿Cómo respalda BALGOD las inversiones de sus miembros?",
    "answer": "Con materiales preciosos, no con criptomonedas ni activos del mercado financiero."
  },
  {
    "question": "¿Qué documentos se requieren para convertirse en miembro de BALGOD?",
    "answer": "Pasaporte, identificación o licencia de conducir de EE. UU. Prueba de domicilio en EE. UU. ITIN, EIN o número de Seguro Social. Cuenta bancaria o tarjeta de débito."
  },
  {
    "question": "¿Qué sucede si el cliente no está de acuerdo con los términos y condiciones establecidos en el contrato?",
    "answer": "Si el cliente no está de acuerdo, debe abstenerse de firmar el contrato, ya que no se permiten modificaciones personalizadas basadas en preferencias individuales."
  },
  {
    "question": "¿Qué debe ser capaz de hacer el cliente al firmar este contrato?",
    "answer": "El cliente debe ser una persona natural con capacidad física y mental para comprometerse a firmar el contrato."
  },
  {
    "question": "¿Cómo deben hacerse los pagos según el contrato?",
    "answer": "Los pagos deben realizarse de acuerdo con el cronograma de pagos acordado y el número de plazos, ya sea a través de las cuentas proporcionadas por BALGOD o mediante cargos realizados a la cuenta del cliente según lo especificado en la Solicitud-Contrato."
  },
  {
    "question": "¿Cómo debe utilizarse el crédito proporcionado por el cliente a BALGOD?",
    "answer": "El crédito proporcionado debe destinarse a inversiones en negocios mineros, bienes raíces, hidrocarburos y construcción de gasoductos."
  },
  {
    "question": "¿Qué tipos de modificaciones son permitidas en el contrato?",
    "answer": "Las modificaciones solo se permiten en los siguientes casos: cambio de nombre legal, cambio de dirección, cambio de nombre legal del beneficiario y extensión de los plazos de pago de la cuota de membresía."
  },
  {
    "question": "¿Cuál es la edad mínima para utilizar los servicios de BALGOD?",
    "answer": "Los servicios están destinados a usuarios que tengan al menos 21 años. Las personas menores de 21 años no pueden utilizar ni registrarse en los servicios."
  },
  {
    "question": "¿Qué debe hacer el CLIENTE para ejecutar este contrato?",
    "answer": "El CLIENTE debe firmar la Solicitud-Contrato, entendiendo que al firmarlo constituye su consentimiento expreso para el acuerdo de crédito."
  },
  {
    "question": "¿Cómo puede el CLIENTE firmar la Solicitud-Contrato?",
    "answer": "El CLIENTE puede firmar la Solicitud-Contrato utilizando su huella dactilar, firma manuscrita o firma electrónica, según lo habilite BALGOD."
  },
  {
    "question": "¿Qué valor tiene la huella dactilar al firmar el contrato?",
    "answer": "La huella dactilar se considerará un sustituto de la firma manuscrita de las partes en este contrato y tendrá el mismo efecto vinculante y consecuencias legales, demostrando claramente la intención de las partes de ejecutar el contrato."
  },
  {
    "question": "¿Qué cubre el contrato de BALGOD MATCH en relación con el crédito?",
    "answer": "Este contrato cubre la concesión de un crédito de liquidez que el CLIENTE extiende a BALGOD, cuyas características, términos y condiciones se describen en la página de portada del crédito y en la sección \"Características del Crédito\" de la Solicitud-Contrato."
  },
  {
    "question": "¿Cómo puede reducirse el límite de crédito?",
    "answer": "El límite de crédito puede reducirse según la capacidad de pago y comportamiento del CLIENTE. Tal reducción será comunicada al CLIENTE a través del próximo estado de cuenta, correo electrónico, carta, teléfono o cualquier otro medio electrónico."
  },
  {
    "question": "¿Puede BALGOD aumentar el límite de crédito?",
    "answer": "Sí, BALGOD puede aumentar el límite de crédito previa solicitud y/o autorización del CLIENTE, según la capacidad de pago y comportamiento del CLIENTE, aunque no está obligado a hacerlo."
  },
  {
    "question": "¿Cómo puede reducirse el monto del crédito?",
    "answer": "El monto del crédito puede reducirse por los montos que BALGOD incurra para el pago de primas de seguros, según se detalla en la Cláusula de Seguro del contrato de BALGOD MATCH."
  },
  {
    "question": "¿Cómo será informado el CLIENTE de un posible aumento en su línea de crédito?",
    "answer": "BALGOD puede aumentar el monto del crédito basado en el comportamiento del CLIENTE enviando una oferta al CLIENTE a través de los métodos de comunicación establecidos. El CLIENTE tendrá 30 días hábiles para aceptar o rechazar el aumento."
  },
  {
    "question": "¿Qué parte del contrato se le proporciona al CLIENTE al firmar?",
    "answer": "BALGOD proporcionará al CLIENTE la página de portada del crédito, que es parte integral de este contrato, junto con la tabla de amortización."
  },
  {
    "question": "¿Cuánto puede retirar el CLIENTE durante el término del contrato?",
    "answer": "El CLIENTE puede solicitar un retiro de hasta el 75% del saldo pendiente en el momento de la solicitud, excluyendo los intereses mencionados en la Solicitud-Contrato, una vez que se haya completado el contrato de 104 semanas/2 años."
  },
  {
    "question": "¿Cómo puede disponer el CLIENTE del crédito?",
    "answer": "El CLIENTE puede disponer del crédito a través de los depósitos realizados por BALGOD en la cuenta del CLIENTE, ya sea en su totalidad o en parte, en una o más transacciones."
  },
  {
    "question": "¿Qué debe proporcionar el CLIENTE al ejecutar el contrato respecto al crédito?",
    "answer": "El CLIENTE debe proporcionar el recibo más amplio y efectivo según lo exija la ley para el monto financiado."
  },
  {
    "question": "¿Qué canales están disponibles para solicitar la disposición del crédito?",
    "answer": "Los canales disponibles son: a) A través de cualquier sucursal de BALGOD, b) A través de retiros electrónicos bancarios, c) A través de medios automatizados."
  },
  {
    "question": "¿Qué debe cumplir el CLIENTE al hacer disposiciones a través de los canales mencionados?",
    "answer": "El CLIENTE debe cumplir con las disposiciones de la cláusula titulada \"OPERACIONES QUE PUEDEN REALIZARSE UTILIZANDO SISTEMAS AUTOMATIZADOS, EQUIPOS, MEDIOS ELECTRÓNICOS O TARJETAS Y CONTRATACIÓN A TRAVÉS DE MEDIOS ELECTRÓNICOS,\" y, si corresponde, el acuerdo que el CLIENTE tenga con BALGOD respecto al uso de servicios bancarios a través de medios automatizados."
  },
  {
    "question": "¿Qué sucede si el CLIENTE solicita una disposición a través de medios automatizados en días no laborables o fuera del horario comercial?",
    "answer": "Las disposiciones solicitadas a través de medios automatizados en días no laborables o fuera del horario comercial se acreditarán al siguiente día hábil."
  },
  {
    "question": "¿Qué información proporcionará BALGOD antes de cada disposición adicional del crédito?",
    "answer": "BALGOD mostrará la tasa fija anual que el CLIENTE recibirá por cada disposición a través de los canales de comunicación."
  },
  {
    "question": "¿Cómo se verifican las disposiciones realizadas por el CLIENTE?",
    "answer": "Las disposiciones realizadas por el CLIENTE se verificarán con los registros contables correspondientes de los depósitos realizados, según lo especificado en la sección \"Características del crédito\" de la Solicitud-Contrato."
  },
  {
    "question": "¿Bajo qué condiciones se pueden realizar disposiciones del crédito?",
    "answer": "Las disposiciones solo pueden realizarse si no hay incumplimiento por parte del CLIENTE con respecto a las obligaciones establecidas en este contrato, si los sistemas automatizados a través de los cuales se solicitan disposiciones están disponibles, y si no ocurre ninguna de las causas de vencimiento anticipado establecidas en el contrato."
  },
  {
    "question": "¿Puede BALGOD limitar las disposiciones del crédito?",
    "answer": "Sí, BALGOD se reserva el derecho de limitar el número y la cantidad a disponer, y dicha limitación será notificada en el siguiente estado de cuenta."
  },
  {
    "question": "¿Cuál es la duración del contrato?",
    "answer": "La duración del contrato es indefinida y se especificará al momento de la firma del acuerdo."
  },
  {
    "question": "¿Quién establece el plazo de reembolso del crédito?",
    "answer": "El CLIENTE establece el plazo de reembolso del crédito, el cual se indicará en el estado de cuenta del crédito y en la Solicitud-Contrato."
  },
  {
    "question": "¿Puede el CLIENTE cancelar el crédito?",
    "answer": "Sí, el CLIENTE puede cancelar el crédito sin responsabilidad dentro de los 6 (seis) días hábiles posteriores a la firma del acuerdo, o un día antes del pago automatizado de la semana 2 (dos), siempre que BALGOD no haya utilizado ni activado el crédito."
  },
  {
    "question": "¿Cómo puede el CLIENTE solicitar la terminación anticipada del contrato?",
    "answer": "El CLIENTE puede solicitar la terminación anticipada en cualquier momento presentando una solicitud por escrito a través de los canales de contacto proporcionados por BALGOD, o por medios electrónicos si se ha acordado previamente."
  },
  {
    "question": "¿Qué sucede una vez que BALGOD recibe la solicitud de terminación?",
    "answer": "Una vez que BALGOD recibe la solicitud, bloqueará la línea de crédito correspondiente, lo que significa que el CLIENTE no podrá realizar más depósitos a la línea de crédito."
  },
  {
    "question": "¿Existen cargos por la terminación anticipada del contrato?",
    "answer": "BALGOD no cobrará ninguna comisión por la terminación anticipada del contrato, y el CLIENTE no será responsable de ningún cargo incurrido después de la terminación del contrato, excepto por aquellos ya incurridos pero no reflejados."
  },
  {
    "question": "¿Qué sucede con los productos o servicios adicionales vinculados al contrato si el contrato principal es cancelado?",
    "answer": "Si un producto o servicio adicional no puede existir sin este contrato, su terminación dará lugar a la terminación simultánea de esos productos o servicios adicionales. Si esos productos pueden existir de forma independiente, las condiciones de los productos restantes pueden cambiar."
  },
  {
    "question": "¿Cómo procederá BALGOD si existen deudas pendientes al momento de la solicitud de terminación?",
    "answer": "Si existen deudas pendientes, BALGOD notificará al CLIENTE dentro de un día hábil sobre el saldo pendiente y, dentro de los 5 (cinco) días hábiles posteriores a la recepción de la solicitud, proporcionará la cantidad exacta que debe pagarse para saldar el contrato."
  },
  {
    "question": "¿Qué sucede si existe un saldo a favor del CLIENTE al terminar el contrato?",
    "answer": "Si existe un saldo a favor del CLIENTE, BALGOD lo entregará en la fecha de terminación. Si el CLIENTE no necesita visitar la sucursal, el saldo estará disponible a través de la cuenta proporcionada por el CLIENTE."
  },
  {
    "question": "¿Qué sucede si el CLIENTE desea cancelar el contrato a través de otra institución financiera?",
    "answer": "El CLIENTE puede acordar por escrito la terminación del contrato a través de otra institución financiera, que se convertirá en el acreedor y realizará los procedimientos necesarios, cobrando una comisión por tales acciones."
  },
  {
    "question": "¿Cómo procederá BALGOD si se utiliza una institución financiera receptora para la terminación del contrato?",
    "answer": "BALGOD proporcionará a la institución financiera receptora la información necesaria sobre el saldo y otros detalles para la terminación, y una vez completada la transferencia de fondos, todos los derechos y obligaciones bajo el contrato serán extinguidos."
  },
  {
    "question": "¿Qué sucede si BALGOD es la institución financiera receptora?",
    "answer": "Si BALGOD es la institución receptora, recibirá las solicitudes de terminación de los \"usuarios\" y retendrá los documentos originales que demuestren la intención del usuario de terminar la relación contractual con la institución transferente."
  },
  {
    "question": "¿Cómo puede el CLIENTE disponer del crédito?",
    "answer": "El CLIENTE puede disponer del crédito a través de los depósitos realizados por BALGOD en la cuenta del CLIENTE, ya sea en su totalidad o parcialmente, en una o más transacciones."
  },
  {
    "question": "¿Qué canales están disponibles para que el CLIENTE haga disposiciones del crédito?",
    "answer": "Los canales son: a) A través de cualquier sucursal de BALGOD, b) A través de retiros bancarios electrónicos, c) A través de medios automatizados."
  },
  {
    "question": "¿Qué sucede si el CLIENTE solicita disposiciones fuera del horario comercial o en días no laborables?",
    "answer": "Las disposiciones solicitadas fuera del horario comercial o en días no laborables se acreditarán al siguiente día hábil."
  },
  {
    "question": "¿Qué condiciones deben cumplirse para que el CLIENTE realice una disposición del crédito?",
    "answer": "Las condiciones son: i) No existe incumplimiento por parte del CLIENTE con respecto a ninguna obligación, ii) Los sistemas automatizados deben estar disponibles, iii) No han ocurrido condiciones de terminación anticipada."
  },
  {
    "question": "¿Qué debe hacer el CLIENTE si desea solicitar la terminación anticipada del contrato?",
    "answer": "El CLIENTE debe presentar una solicitud por escrito a través de los canales de contacto proporcionados por BALGOD o, si se ha acordado previamente, a través de medios electrónicos."
  },
  {
    "question": "¿Cuándo se bloqueará la línea de crédito después de que se realice la solicitud de terminación?",
    "answer": "La línea de crédito se bloqueará el mismo día en que BALGOD reciba la solicitud de terminación, y el CLIENTE no podrá realizar más disposiciones."
  },
  {
    "question": "¿Qué sucede con los productos o servicios adicionales vinculados a este contrato si se termina?",
    "answer": "Si los productos o servicios adicionales no pueden existir sin este contrato, su terminación coincidirá con la terminación de este contrato. Si pueden existir de forma independiente, sus condiciones pueden modificarse."
  },
  {
    "question": "¿Qué sucede si el CLIENTE tiene un saldo a su favor después de que el contrato haya sido terminado?",
    "answer": "El saldo a favor del CLIENTE será entregado en la fecha en que se termine el contrato. Si el CLIENTE no necesita visitar la sucursal, el saldo se pondrá a disposición a través de la cuenta especificada por el CLIENTE."
  },
  {
    "question": "¿Qué sucede si el CLIENTE decide terminar el contrato a través de otra institución financiera?",
    "answer": "El CLIENTE puede solicitar la terminación a través de otra institución financiera, la cual liquidará el contrato y realizará los procedimientos necesarios. BALGOD proporcionará la información requerida sobre el saldo y otros detalles."
  },
  {
    "question": "¿Cómo se aplicarán los fondos realizados por el CLIENTE?",
    "answer": "Los fondos se aplicarán en el siguiente orden: i) Impuestos, ii) Comisiones, iii) Intereses monetarios, iv) Prima(s), v) Intereses ordinarios morosos, vi) Saldo principal pendiente, vii) Intereses ordinarios corrientes, viii) Amortización de principal vencido."
  },
  {
    "question": "¿Qué sucede si el CLIENTE quiere reestructurar su crédito antes de la fecha de vencimiento?",
    "answer": "El CLIENTE puede reestructurar su crédito, pero la fecha de vencimiento no debe superar la fecha de expiración del contrato."
  },
  {
    "question": "¿Cómo hará el CLIENTE el pago del crédito?",
    "answer": "El pago del crédito será realizado por el CLIENTE en la oficina de BALGOD, de acuerdo con los pagos y fechas establecidos en el documento firmado, para cubrir el retiro total o parcial del crédito."
  },
  {
    "question": "¿Cómo se determinará la cantidad adeudada por el CLIENTE en cada desembolso?",
    "answer": "Cada desembolso consistirá en la suma del principal, la cantidad correspondiente de intereses, comisiones, primas de seguros aplicables y cualquier otro accesorio generado, junto con el impuesto al valor agregado (IVA) sobre los intereses, comisiones y/o primas de seguros."
  },
  {
    "question": "¿Qué debe hacer el CLIENTE si cambia la frecuencia de su nómina o pagos?",
    "answer": "El CLIENTE debe notificar a BALGOD con anticipación sobre el cambio en la frecuencia de sus pagos para ajustar las fechas de los desembolsos del crédito."
  },
  {
    "question": "¿Cómo se hará el pago de los fondos adeudados por el CLIENTE?",
    "answer": "El pago de los fondos adeudados se realizará mediante un cargo a la cuenta de depósito identificada en la sección \"Características del Crédito\" o cualquier otra cuenta designada por el CLIENTE."
  },
  {
    "question": "¿Qué se considera un préstamo de nómina?",
    "answer": "Un préstamo de nómina es un préstamo en el que BALGOD y el CLIENTE acuerdan que la financiación de las deudas correspondientes se hará mediante cargos a las cantidades en la cuenta ordenante (la cuenta en la que el CLIENTE recibe depósitos o transferencias de pagos de beneficios)."
  },
  {
    "question": "¿Cómo puede el CLIENTE designar un préstamo como préstamo de nómina?",
    "answer": "El CLIENTE puede designar el préstamo como préstamo de nómina ya sea en el momento en que se otorga o en una fecha posterior, utilizando el formulario de débito directo y firmando el mandato a favor de BALGOD, permitiéndole gestionar el débito directo del préstamo con cualquier otra institución financiera que tenga la cuenta ordenante."
  },
  {
    "question": "¿Cuál es el monto máximo que un CLIENTE puede asociar a un préstamo de nómina?",
    "answer": "El CLIENTE puede asociar préstamos, siempre que no superen los $100,000 USD (cien mil dólares estadounidenses)."
  },
  {
    "question": "¿Qué sucede si el CLIENTE revoca el mandato o cancela el débito directo?",
    "answer": "Si el CLIENTE revoca el mandato y/o solicita la cancelación del débito directo, BALGOD estará autorizado a reducir la tasa de interés ordinaria aplicable en 20 puntos porcentuales respecto a la tasa originalmente acordada en el contrato. El CLIENTE será notificado mediante el estado de cuenta y también podrá ser notificado a través de los canales electrónicos acordados con 30 días de antelación antes de que se modifique la tasa de interés ordinaria."
  },
  {
    "question": "¿Quién atenderá las objeciones sobre los cargos al préstamo?",
    "answer": "Las objeciones sobre los cargos serán atendidas por la institución financiera, denominada \"BANCO DEL PRESTATARIO\", con la que el CLIENTE mantiene la cuenta ordenante a la fecha de la solicitud de objeción."
  },
  {
    "question": "¿Puede el CLIENTE cancelar el débito directo en cualquier momento?",
    "answer": "Sí, el CLIENTE puede cancelar el débito directo en cualquier momento y puede realizar pagos directos a las cuentas proporcionadas a BALGOD."
  },
  {
    "question": "¿Cuál es la tasa de interés por pago tardío para el CLIENTE?",
    "answer": "El CLIENTE acepta pagar intereses por demora a partir del día siguiente de la tercera cuota no pagada consecutiva. La tasa se calculará multiplicando la tasa de interés ordinaria por 2 (dos)."
  },
  {
    "question": "¿Cuándo comienzan a generarse los intereses por demora?",
    "answer": "Los intereses por demora comienzan a generarse después de la tercera cuota no pagada consecutiva y continúan hasta que se realice el pago correspondiente."
  },
  {
    "question": "¿Cómo se calcula el interés?",
    "answer": "El interés se calcula basado en un año de 360 días, y se acumulará por el número real de días que el saldo permanezca vencido."
  },
  {
    "question": "¿Qué sucede si el CLIENTE no realiza los pagos después de regularizar su cuenta?",
    "answer": "Si el CLIENTE no realiza los pagos después de regularizar su cuenta, se generarán nuevamente intereses por demora bajo los mismos términos."
  },
  {
    "question": "¿Puede el CLIENTE realizar pagos anticipados de su préstamo?",
    "answer": "Sí, el CLIENTE puede realizar pagos anticipados en cualquier momento, según lo especificado en la solicitud-contrato."
  },
  {
    "question": "¿Qué condiciones deben cumplirse para que BALGOD acepte pagos anticipados?",
    "answer": "El CLIENTE debe solicitar el pago anticipado y estar al día con todos los montos adeudados. El pago anticipado también debe ser igual o superior al monto vencido correspondiente al período."
  },
  {
    "question": "¿Cómo se aplicará el pago anticipado?",
    "answer": "El pago anticipado se aplicará exclusivamente al saldo pendiente."
  },
  {
    "question": "¿Qué sucede si el monto del pago anticipado no es suficiente para amortizar completamente el saldo?",
    "answer": "El CLIENTE debe informar a BALGOD si el pago anticipado debe reducir el monto de los pagos periódicos pendientes o disminuir la cantidad de pagos pendientes."
  },
  {
    "question": "¿Puede el CLIENTE realizar pagos anticipados para periodos futuros?",
    "answer": "Sí, el CLIENTE puede realizar pagos anticipados para períodos no vencidos, los cuales se aplicarán para cubrir los próximos pagos periódicos inmediatos."
  },
  {
    "question": "¿Qué sucede si un pago excede el monto debido?",
    "answer": "El CLIENTE debe proporcionar una declaración escrita firmada autorizando que los fondos excedentes cubran los próximos pagos en lugar de un pago anticipado del principal. O hacerlo a través de la cuenta miembro en www.balgod.com."
  },
  {
    "question": "¿Qué proporciona BALGOD después de recibir pagos anticipados o pagos adelantados?",
    "answer": "BALGOD proporcionará al CLIENTE un calendario de amortización actualizado y un recibo por cada pago anticipado o adelantado recibido."
  },
  {
    "question": "¿Qué comisiones debe pagar el CLIENTE a BALGOD?",
    "answer": "El CLIENTE debe pagar una comisión por la administración del préstamo, que se pagará semanalmente desde el saldo pendiente, así como una comisión por cada desembolso del préstamo y por la cobranza en caso de saldos vencidos y no financiados."
  },
  {
    "question": "¿Cuándo vence la comisión por administración del préstamo?",
    "answer": "La comisión por administración se paga semanalmente desde el saldo pendiente a la cuenta especificada en la solicitud-contrato."
  },
  {
    "question": "¿Cuál es la comisión por desembolso adicional?",
    "answer": "Por cada desembolso del préstamo, el CLIENTE pagará una comisión, cuyo monto está especificado en la solicitud-contrato. Esta se vence cuando se realiza el desembolso."
  },
  {
    "question": "¿Cuándo se genera la comisión de cobranza?",
    "answer": "La comisión de cobranza se genera a partir del sexto día calendario después de la fecha de vencimiento del respectivo desembolso y puede aplicarse hasta tres pagos consecutivos no realizados."
  },
  {
    "question": "¿Está el CLIENTE obligado a pagar la comisión de cobranza?",
    "answer": "Sí, el CLIENTE debe pagar la comisión de cobranza cuando se genere, y se aplicará al saldo vencido y no financiado hasta que el CLIENTE pague por completo los montos vencidos."
  },
  {
    "question": "¿Cuándo incurre el CLIENTE en intereses por pago tardío?",
    "answer": "El CLIENTE incurre en intereses por pago tardío si no paga el monto requerido después del tercer desembolso no pagado consecutivo. La tasa de interés será el doble de la tasa de interés ordinaria."
  },
  {
    "question": "¿Cómo se calculan los intereses por pago tardío?",
    "answer": "Los intereses por pago tardío se calculan sobre un año de 360 días, acumulándose sobre el saldo vencido por el número real de días transcurridos."
  },
  {
    "question": "¿Puede el CLIENTE realizar pagos anticipados o adelantados?",
    "answer": "Sí, el CLIENTE puede realizar pagos anticipados o adelantados en cualquier momento, siempre que esté al día con los pagos de su préstamo y el monto sea igual o superior al pago debido para el período correspondiente."
  },
  {
    "question": "¿Qué comisiones debe pagar el CLIENTE?",
    "answer": "El CLIENTE debe pagar una comisión por la administración del préstamo, los desembolsos adicionales y una comisión por cobranza de saldos vencidos. Estas comisiones están especificadas en el estado de cuenta del crédito y en la solicitud-contrato."
  },
  {
    "question": "¿Cuándo se aplica la comisión de cobranza?",
    "answer": "La comisión de cobranza se aplica a partir del sexto día calendario después de la fecha de vencimiento del respectivo desembolso y puede aplicarse hasta tres pagos consecutivos no realizados."
  },
  {
    "question": "¿Qué sucede si el CLIENTE tiene desembolsos vencidos?",
    "answer": "Si el CLIENTE tiene desembolsos vencidos, BALGOD está autorizado a cobrar el monto vencido contra cualquier deuda líquida y exigible que el CLIENTE tenga en sus cuentas de depósito en BALGOD."
  },
  {
    "question": "¿Cuándo será notificado el CLIENTE sobre el cargo vencido?",
    "answer": "BALGOD notificará al CLIENTE a través del estado de cuenta después de realizar el cargo vencido."
  },
  {
    "question": "¿Qué sucede si el CLIENTE muere?",
    "answer": "El beneficiario del CLIENTE debe notificar a BALGOD dentro de los 7 días hábiles siguientes al fallecimiento. El saldo pendiente se congelará hasta que el beneficiario reclame formalmente el saldo con la documentación requerida."
  },
  {
    "question": "¿Puede el CLIENTE designar múltiples beneficiarios?",
    "answer": "No, el CLIENTE solo puede designar un beneficiario irrevocable, y esto debe estar indicado en la página principal del contrato."
  },
  {
    "question": "¿Cuándo puede BALGOD declarar el monto del préstamo vencido antes del término acordado?",
    "answer": "BALGOD puede declarar el préstamo vencido antes del término acordado si el CLIENTE no cumple con el contrato o en casos específicos como quiebra o fondos insuficientes en la cuenta de depósito."
  },
  {
    "question": "¿Puede el CLIENTE ser exonerado de cumplir con las obligaciones?",
    "answer": "Sí, pero solo con el consentimiento previo por escrito de los representantes legales de BALGOD."
  },
  {
    "question": "¿Está el CLIENTE obligado a cumplir con sus obligaciones en caso de un evento fortuito o de fuerza mayor?",
    "answer": "Sí, el CLIENTE está obligado a cumplir con sus obligaciones, incluso en casos de eventos fortuitos o fuerza mayor."
  },
  {
    "question": "¿Tiene BALGOD derecho a modificar los términos del crédito?",
    "answer": "Sí, BALGOD se reserva el derecho de restringir el monto o el plazo del crédito, o incluso de terminar el contrato, dando aviso previo por escrito al CLIENTE."
  },
  {
    "question": "¿Sigue el CLIENTE obligado a pagar si el contrato es rescindido?",
    "answer": "Sí, el CLIENTE sigue obligado a financiar completamente las cantidades ofrecidas y sus accesorios según el contrato, hasta que se realicen todas las aportaciones."
  },
  {
    "question": "¿La omisión de derechos por parte de BALGOD implica una renuncia a esos derechos?",
    "answer": "No, la omisión de derechos no implica una renuncia. El ejercicio parcial o singular de los derechos se regirá por el contenido del contrato, no por los títulos de las cláusulas."
  },
  {
    "question": "¿Cuándo empieza el BALGOD Match?",
    "answer": "El BALGOD Match comienza después de las contribuciones monetarias realizadas durante el primer año (52 semanas o 26 períodos quincenales)."
  },
  {
    "question": "¿Qué porcentaje de reembolso ofrece el BALGOD Match?",
    "answer": "Ofrece un reembolso del 100% de la TAE basado en las contribuciones totales realizadas durante el primer año."
  },
  {
    "question": "¿Cuál es el límite máximo de contribución durante el primer año?",
    "answer": "El límite máximo es de $100,000 USD por miembro durante el primer año."
  },
  {
    "question": "¿Es reembolsable la cuota de membresía?",
    "answer": "No, la cuota de membresía no es reembolsable y no forma parte del BALGOD Match."
  },
  {
    "question": "¿Cuál es el costo total de la membresía?",
    "answer": "El costo total de la membresía es de $832 USD."
  },
  {
    "question": "¿Cuál es el pago semanal mínimo?",
    "answer": "El pago semanal mínimo es de $30 USD o $60 USD quincenal."
  },
  {
    "question": "¿Se aceptarán contribuciones monetarias después del primer año?",
    "answer": "No, no se aceptarán contribuciones monetarias después del primer año, excepto el pago de la cuota de membresía según lo estipulado en la cláusula."
  },
  {
    "question": "¿Puedo retirar mis contribuciones y activos antes de que termine el contrato?",
    "answer": "No, no se podrán retirar las contribuciones y los activos hasta que se complete el contrato."
  },
  {
    "question": "¿Cómo se muestra el BALGOD MATCH en la cuenta del usuario?",
    "answer": "El BALGOD MATCH se mostrará en la cuenta del usuario desde el inicio, pero su efecto comenzará en el segundo año, según la cláusula."
  },
  {
    "question": "¿Cuál es la contribución mínima total para el primer año?",
    "answer": "La contribución mínima total para el primer año es de $1,560 USD, con un límite máximo de $100,000 USD."
  },
  {
    "question": "¿Cuál es el costo total de la membresía por dos años?",
    "answer": "El costo total de la membresía por dos años es de $832 USD."
  },
  {
    "question": "¿Se aceptarán contribuciones monetarias después de la semana 53?",
    "answer": "No, no se aceptarán contribuciones monetarias después de la semana 53, excepto el pago de la cuota de membresía."
  },
  {
    "question": "¿Qué sucede con la contribución monetaria en el segundo año?",
    "answer": "No se aceptarán contribuciones monetarias adicionales en el segundo año, a partir de la semana 53, excepto el pago de la cuota de membresía."
  },
  {
    "question": "¿Cuántos días naturales tiene un CLIENTE para solicitar una aclaración sobre una transacción inferior a $500 USD?",
    "answer": "90 días."
  },
  {
    "question": "¿Para transacciones que superen los $10,000 USD, dentro de cuántos días naturales debe el CLIENTE presentar su objeción por escrito a BALGOD?",
    "answer": "45 días."
  },
  {
    "question": "¿Cuál es el período máximo dentro del cual BALGOD debe proporcionar una respuesta por escrito después de recibir la documentación requerida del CLIENTE?",
    "answer": "45 días (o 180 días para transacciones internacionales)."
  },
  {
    "question": "¿Qué debe hacer el CLIENTE si desea disputar una transacción superior a $10,000 USD?",
    "answer": "Visitar una sucursal de BALGOD para presentar la disputa, o hacerlo a través de la cuenta miembro en www.balgod.com."
  }
];